// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__30_MB","ranges":"BmiRanges_ranges__2f-GQ"};